import { Box } from "@mui/material";
import styled from "styled-components";

export const NotifyStyled = styled(Box)`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  .header {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    h5 {
      font-weight: 400;
    }
  }
  .content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 429px));
    gap: 16px;
    width: 100%;
  }
`;
